import { backendApi, authenticationApi } from 'src/api';
import { resetAccount } from 'src/state/account/account-slice';
import { resetServiceLocation } from 'src/state/address/address-slice';
import { resetAuth } from 'src/state/auth/auth-slice';
import { resetCart } from 'src/state/cart/cart-slice';
import { resetOrderState } from 'src/state/order/order-slice';
import { AppDispatch } from 'src/state/types';

export const resetStateActionCreator = () => (dispatch: AppDispatch) => {
  dispatch(backendApi.util.resetApiState());
  dispatch(authenticationApi.util.resetApiState());
  dispatch(resetAccount());
  dispatch(resetServiceLocation());
  dispatch(resetCart());
  dispatch(resetOrderState());
  dispatch(resetAuth());
};
